/* eslint-disable max-lines */
import {join, lensPath, pathOr} from 'ramda';

import {DetailType, MeasurementType} from 'constants/flow/flowTypesProduct';

import {UpsellListItemType} from 'reducers/upsellItems/upsellItemsType';

export const REFERRAL_PROMOCODE_KEY = 'referralPromoCode';
export const MARKETING_API_PROMOCODE_KEY = 'marketingAPIPromoCode';
export const DETAILS: Array<DetailType> = [
    {
        key: 'gender',
        name: 'Gender',
        lens: pathOr([], ['genders']),
        compose: join(' / '),
    },
    {
        key: 'material',
        name: 'Material',
        lens: pathOr([], ['frame', 'materials']),
        compose: join(', '),
    },
    {
        key: 'color',
        name: 'Color',
        lens: pathOr('', ['color', 'label']),
    },
    {
        key: 'brand',
        name: 'Brand',
        // @ts-ignore
        lens: pathOr('', ['label']),
    },
];

export const MEASUREMENTS: Array<MeasurementType> = [
    {
        key: 'lens_width',
        name: 'Lens Width',
        lens: lensPath(['frame', 'lensWidth']),
    },
    {
        key: 'lens_height',
        name: 'Lens Height',
        lens: lensPath(['frame', 'lensHeight']),
    },
    {
        key: 'bridge_width',
        name: 'Bridge Width',
        lens: lensPath(['frame', 'bridgeWidth']),
    },
    {
        key: 'temple_length',
        name: 'Temple Length',
        lens: lensPath(['frame', 'templeLength']),
    },
    {
        key: 'total_width',
        name: 'Total Width',
        lens: lensPath(['frame', 'width']),
    },
];
export const PRODUCT_TYPES = {
    READERS: 'readers',
    SUNGLASSES: 'sunglasses',
    EYEGLASSES: 'eyeglasses',
    CONTACT_LENSES: 'contact_lenses',
    ACCESSORY: 'accessories',
    GIFT: 'gift',
} as const;

export const POWERS_OPTION_ID = 4176;
export const POWERS_CATEGORY_FILTER_KEY = 'power';
export const SELECTED_POWER_STORE_ID = 'readersSelectedPower';
export const PRODUCT_BANNER_PLACEHOLDER = 'mobile-pdp-reminder';
export const LOW_QUANTITY = 3;
export const Q_COLORS_FULL_MODE = 6;
export const COLOR_NAME_LENGTH_LIMIT = 20;
export const COLOR_NAME_LENGTH = 18;
export const AVAILABLE_LENS_FEATURES = ['Polarized', 'Mirrored', 'Gradient'];

export const IMAGE_ALIAS = {
    WOMEN_180: '180-rotation-women',
    MEN_180: '180-rotation-men',
    ROTATION_180: '180-rotation',
    ROTATION_360: '360-rotation',
};

export const TAB_NAME_FOR_SEND_ANALYTICS = {
    shippingAndReturns: 'Shipping & Returns',
    howItLooks: 'How It Looks',
    info: 'Product Information',
    reviews: 'Reviews',
};

export const PRICE_MATCH_BRANDS = ['Ray-Ban', 'Oakley'];

export const UPSELL_ALIASES = {
    INSURANCE: 'insurance_20_20-1-year',
    INSURANCE_SECOND_YEAR: 'insurance_20_20-2-year',
    INSURANCE_OLD: 'insurance_20_20',
    DIGITAL_BLOCK: 'digitalBlock',
    UV: 'uv',
    HYDROPHOBIC: 'hydrophobic',
    ANTI_FOG: 'antiFog',
};

export const INSURANCES = [UPSELL_ALIASES.INSURANCE, UPSELL_ALIASES.INSURANCE_SECOND_YEAR];

export const UPSELLS_LIST: Array<UpsellListItemType> = [
    {
        alias: 'hydrophobic',
        title: 'Super Hydrophobic',
        description: 'Easy-to-clean, water-repelleing lenses.',
        popupTitle: 'Super Hydrophobic Coating',
        postScriptum: '',
    },
    {
        alias: 'insurance_20_20',
        title: '1-Year Coverage',
        description: 'Protect your glasses. Comprehensive \n1-year warranty.',
        popupTitle: '20/20 Enhanced Coverage',
        postScriptum: '',
    },
    {
        alias: 'insurance_20_20-1-year',
        title: '1-Year Coverage',
        description: 'Protect your glasses. Comprehensive \n1-year warranty',
        popupTitle: '20/20 Enhanced Coverage',
        postScriptum: '',
    },
    {
        alias: 'insurance_20_20-2-year',
        title: '2-Year Coverage',
        description: 'Enjoy a limited-time discount on our \n2-year coverage plan.',
        popupTitle: '20/20 Enhanced Coverage',
        postScriptum: '',
    },
    {
        alias: 'digitalBlock',
        title: 'Blue Light Protection',
        description: 'Protect your eyes from blue light.',
        popupTitle: 'Blue Light Lenses',
        postScriptum: '',
    },
    {
        alias: 'uv',
        title: 'Premium Lens Coatings',
        description: 'UV protective + anti-reflective coatings.',
        popupTitle: '',
        postScriptum: '',
    },
    {
        alias: 'antiFog',
        title: 'Anti-Fog Coating',
        description: 'Stop your glasses from fogging up & keep lenses clear.',
        popupTitle: 'Anti-Fog Coating',
        postScriptum: '',
    },
];

export const DY_COLOR_ATTR = 'Color';
export const DY_SIZE_ATTR = 'Size';

export const EXT_LABS = {
    SHAMIR: 'Shamir',
};

export const CONTACTS_LENSES_TYPES = {
    MULTIFOCAL: 'Multifocal',
    SINGLE_VISION: 'Single vision',
    TORIC: 'Toric & Astigmatism',
};

export const PRODUCT_STOCK_STATUS = {
    IN_STOCK: 'in_stock',
    LOW_STOCK: 'low_stock',
    OUT_OF_STOCK: 'out_of_stock',
};

export const COLLAPSE_TYPES = {
    reviews: 'PDP_reviews',
};
